function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".cls-1,.primary-38{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary-38{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "cls-1",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("rect", {
  className: "white",
  x: 32,
  y: 56,
  width: 192,
  height: 64
}), React.createElement("polygon", {
  className: "white",
  points: "144 224 112 224 112 140.8 104 133.87 96 120 160 120 152 133.87 144 140.8 144 224"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("rect", {
  className: "highlights",
  x: 32,
  y: 80,
  width: 192,
  height: 40
})), React.createElement("g", {
  id: "primary"
}, React.createElement("rect", {
  className: "primary-38",
  x: 32,
  y: 56,
  width: 192,
  height: 64
}), React.createElement("polygon", {
  className: "primary-38",
  points: "144 224 112 224 112 144 96 139.2 96 120 160 120 160 139.2 144 144 144 224"
}), React.createElement("line", {
  className: "primary-38",
  x1: 64,
  y1: 32,
  x2: 80,
  y2: 32
}), React.createElement("line", {
  className: "primary-38",
  x1: 120,
  y1: 32,
  x2: 136,
  y2: 32
}), React.createElement("line", {
  className: "primary-38",
  x1: 176,
  y1: 32,
  x2: 192,
  y2: 32
}), React.createElement("line", {
  className: "primary-38",
  x1: 72,
  y1: 32,
  x2: 72,
  y2: 48
}), React.createElement("line", {
  className: "primary-38",
  x1: 128,
  y1: 32,
  x2: 128,
  y2: 48
}), React.createElement("line", {
  className: "primary-38",
  x1: 184,
  y1: 32,
  x2: 184,
  y2: 48
})));
var SvgBillboard = function SvgBillboard(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgBillboard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Billboard.a5e097e1.svg";
export { ForwardRef as ReactComponent };